import type { propsApiUser } from '~/services/http/interfaces';

import type { propsUserData } from './interfaces';

export function mapApiUserToState(user: propsApiUser): Partial<propsUserData> {
  const farm = user.primaryFarm;
  return {
    id: user.id,
    userId: user.id,
    active: true,
    role: 'user',
    fullName: user.profile?.fullName ?? '',
    userType: user.profile?.documentType === 'CNPJ' ? 'PJ' : 'PF',
    document: user.profile?.document,
    emailVerified: user.emailVerified,
    contact: {
      email: user.email,
      phone: user.profile?.phone ?? '',
    },
    farm: farm
      ? {
          farmName: farm.name,
          activity: farm.activity,
          hectares: farm.hectares ?? undefined,
          livestockHeadCount: farm.livestockHeadCount ?? undefined,
          annualRevenue: farm.annualRevenueCents,
        }
      : {},
  };
}
